import { FC, ReactNode } from "react"
import {CMSSection, CTAType} from "../../../models"
import { Modal, Row, Col, ModalProps } from "antd"
import React from "react"
import { JCMSImage } from "../../../JCMSImage"
import { JHTML } from "../../../JHTML"
import './JCMSStaticModal.scss'
import {JCMSCTA} from "../../../JCMSCTA";


export interface JCMSStaticModalProps extends CMSSection {
    open?: boolean;
    onCancel?: ()=>void,
    modalProps?: ModalProps
    beforeText?: ReactNode,
    afterText?: ReactNode,
    btnProps?: {
        title?: string,
        action?: () => void,
        type?: CTAType
    }
}

export const JCMSStaticModal: FC<JCMSStaticModalProps> = props => {


    if (!props.enabled) return <></>
    return (
        <Modal 
            width={'1118px'} 
            centered
            footer={false} 
            {...props.modalProps} 
            open={props.open} 
            onCancel={props.onCancel} 
            className="jcms-modal"
        >
            <Row>
                <Col xs={24} sm={12} className='jcms-modal-left-side' >
                    <JCMSImage image={props.image} />
                </Col>
                <Col xs={24} sm={12} className='jcms-modal-right-side'>
                    <JHTML.Title html={props.title || ''} />
                    {props.beforeText}
                    <JHTML.Text html={props.text || ''} />
                    {props.afterText}
                    {props?.btnProps && <div className='jcms-modal-right-side-btn'>
                        <JCMSCTA title={props?.btnProps?.title} action={props?.btnProps?.action} type={props?.btnProps?.type || 'BUTTON'}/>
                    </div>}
                </Col>
            </Row>
        </Modal>
    )
}